var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"password-reset-mail-input-page"},[_c('sub-header-section',{attrs:{"pageTitle":_vm.$tc('PasswordResetPage.subTitle')}}),_c('password-reset-mail-input-pane',{on:{"success-regist":_vm.moveToSend}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }